export default __webpack_public_path__ + "static/media/arrow-hp-prev.34682572.png";